// extracted by mini-css-extract-plugin
export default {"header":"Privacy_header__IC7Zc","body":"Privacy_body__B8Op7","container":"Privacy_container__gPqib","sidebar":"Privacy_sidebar__-pv-k","active":"Privacy_active__yI+HH"};